import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {MultilineInputComponent} from '../multiline-input/multiline-input.component';
import {FormElementsService} from '../../services/form-elements.service';
import {VupchCitation, VupchOutput} from '../../../forms/modules/vupch/models/vupch';

@Component({
  selector: 'app-multiline-select',
  templateUrl: './multiline-select.component.html',
  styleUrls: ['./multiline-select.component.scss']
})
export class MultilineSelectComponent extends MultilineInputComponent implements OnInit {
  @Output() inputValidationState = new EventEmitter();
  @ViewChild('inputElement') inputElement: ElementRef;
  public initialString: string;

  constructor(protected formElementsService: FormElementsService) {
    super(formElementsService);
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
    this.initialString = JSON.parse(JSON.stringify(this.getObjectProperty()));
  }

  public setSelectedOption(event?: any): void {
    const valueToEmit = this.getValueToEmit(event);
    this.objectChosen.emit(this.getValueFromOptions(event));
    switch (this.inputId) {
      case 'VupchOutput.detail' :
        this.handleVupchOutput(valueToEmit);
        break;
      case 'Vtc.idEpcPublication':
        this.emitValue(valueToEmit, true);
        break;
      default:
        this.emitValue(valueToEmit, this.objectToSet !== null);
        break;
    }
    this.inputValidationState.emit(true);
  }

  public checkInputValidity(): void {
    this.inputValidationState.emit(this.inputElement.nativeElement.classList.contains('ng-valid'));
  }

  private handleVupchOutput(valueToEmit): void {
    if (this.objectProperties.includes('citedPublication')) {
      const emitObject = {
        idEpcCitation: null,
        idEpcPublication: valueToEmit?.idEpcPublication,
        citedPublication: valueToEmit?.detail,
        citingPublication: '',
      } as VupchCitation;
      this.emitValue(emitObject, this.objectToSet !== null);
    } else {
      const emitObject = {
        detail: valueToEmit?.detail,
        idEpcPublication: valueToEmit?.idEpcPublication,
      } as VupchOutput;
      this.emitValue(emitObject, this.objectToSet !== null);
    }
  }
}
